export const countryDropdownConfig = {
    height: 40,
    width: 320,
};
